import axios from 'axios';
import { OrganizationGroup, GroupSummary, GroupType } from '../types/groups';
import { API_URL } from '../constants/urls';

export const groupsService = {
  // Get all groups
  async getGroups(
    organizationId: string,
    groupType?: GroupType,
  ): Promise<OrganizationGroup[]> {
    const params = new URLSearchParams({ organization_id: organizationId });
    if (groupType) {
      params.append('group_type', groupType);
    }
    const response = await axios.get(`${API_URL}/groups?${params.toString()}`);
    return response.data;
  },

  // Get groups summary for dropdowns
  async getGroupsSummary(
    organizationId: string,
    groupType?: GroupType,
  ): Promise<GroupSummary[]> {
    const params = new URLSearchParams({ organization_id: organizationId });
    if (groupType) {
      params.append('group_type', groupType);
    }
    const response = await axios.get(
      `${API_URL}/groups/summary?${params.toString()}`,
    );
    return response.data;
  },

  // Create a new group
  async createGroup(
    organizationId: string,
    groupData: Partial<OrganizationGroup>,
  ): Promise<OrganizationGroup> {
    const response = await axios.post(
      `${API_URL}/groups?organization_id=${organizationId}`,
      groupData,
    );
    return response.data;
  },

  // Update a group
  async updateGroup(
    organizationId: string,
    groupId: string,
    groupData: Partial<OrganizationGroup>,
  ): Promise<OrganizationGroup> {
    const response = await axios.put(
      `${API_URL}/groups/${groupId}?organization_id=${organizationId}`,
      groupData,
    );
    return response.data;
  },

  // Delete a group
  async deleteGroup(organizationId: string, groupId: string): Promise<void> {
    await axios.delete(
      `${API_URL}/groups/${groupId}?organization_id=${organizationId}`,
    );
  },
};
